import { render, staticRenderFns } from "./LabSupplyFrameInfo.vue?vue&type=template&id=21936974"
import script from "./LabSupplyFrameInfo.vue?vue&type=script&lang=js"
export * from "./LabSupplyFrameInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports